<template>
  <div>
    <CChartBar :datasets="defaultDatasets" :labels="labels" :options="options" :style="`height: ${height}px;`" />
  </div>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";

export default {
  name: "CChartBarExample",
  props: {
    data: {
      type: Object,
      default: {}
    },
    height: {
      type: Number,
      default: 150,
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    axisTitleFontSize: {
      type: Number,
      default: 16,
    },
    graphTitle:{
      type: String,
      default: ""
    },
  },
  components: { CChartBar },
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          // Grid line will shown when make the 'gridLines' properties 'true' for both X and Y axis in 'scales'

          // x-Axis
          xAxes: [
            {
              gridLines: {
                display: true,
                offsetGridLines: false,
                drawOnChartArea: false
              },
              ticks: {
                fontSize: this.fontSize,
                fontStyle: 'bold',
              },
              scaleLabel: {
                display: true,
                // x-Axis "Label"
                labelString: this.data.xAxisLabel || "",
                fontSize: this.axisTitleFontSize,
                fontStyle: 'bold',
              },
            }
          ],

          // y-Axis
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: this.fontSize,
                fontStyle: 'bold',
                stepSize: 1,   
              },
              gridLines: {
                display: true,
                offsetGridLines: false,
                drawOnChartArea: false
              },
              scaleLabel: {
                display: true,
                // y-Axis "Label"
                labelString: this.data.yAxisLabel ||  "",
                fontSize: this.axisTitleFontSize,
                fontStyle: 'bold',
              }
            }
          ]
        },
        title: {
            display: true,
            text: this.graphTitle,
            fontStyle: 'bold',
            fontSize: 18,
        }
      },
    };
  },
  computed: {
    defaultDatasets() {
      return [
        {
          barPercentage: 0.5,
          barThickness: this.barThickness,
          // maxBarThickness: 8,
          // minBarLength: 2,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: 0.5,
          data: this.getData
        }
      ];
    },
    labels() {
      return this.data.cdata.map(val => val.label);
    },
    getData() {
      return this.data.cdata.map(val => val.value);
    },
    borderColor() {
      return this.data.cdata.map(val => val.borderColor);
    },
    backgroundColor() {
      return this.data.cdata.map(val => val.backgroundColor);
    },
    barThickness() {
      return this.data.barThickness;
    }
  }
};
</script>


